// import { Link } from 'react-router-dom';

// const Navbar = () => {
//   return (
//     <nav style={styles.nav}>
//       <h2 style={styles.logo}>PaintPro</h2>
//       <ul style={styles.ul}>
//         <li><Link to="/">Home</Link></li>
//         <li><Link to="/about">About</Link></li>
//         <li><Link to="/services">Services</Link></li>
//         <li><Link to="/gallery">Gallery</Link></li>
//         <li><Link to="/contact">Contact</Link></li>
//       </ul>
//     </nav>
//   );
// };

// const styles = {
//   nav: { display: 'flex', justifyContent: 'space-between', padding: '1rem', background: '#333', color: '#fff' },
//   logo: { marginLeft: '1rem' },
//   ul: { display: 'flex', listStyle: 'none', gap: '1rem', marginRight: '1rem' }
// };

// export default Navbar;

// import { Link } from 'react-scroll';

// const Navbar = () => {
//   return (
//     <nav style={styles.nav}>
//       <h2 style={styles.logo}>PaintPro</h2>
//       <ul style={styles.ul}>
//         <li><Link to="home" smooth={true} duration={500}>Home</Link></li>
//         <li><Link to="about" smooth={true} duration={500}>About</Link></li>
//         <li><Link to="services" smooth={true} duration={500}>Services</Link></li>
//         <li><Link to="gallery" smooth={true} duration={500}>Gallery</Link></li>
//         <li><Link to="contact" smooth={true} duration={500}>Contact</Link></li>
//       </ul>
//     </nav>
//   );
// };

// const styles = {
//   nav: {
//     position: 'fixed',
//     width: '100%',
//     top: 0,
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '1rem',
//     background: '#333',
//     color: '#fff',
//     zIndex: 1000
//   },
//   logo: { marginLeft: '1rem' },
//   ul: { display: 'flex', listStyle: 'none', gap: '1rem', marginRight: '1rem' }
// };

// export default Navbar;

// import { Link } from 'react-scroll';

// const Navbar = () => {
//   return (
//     <nav
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         backgroundColor: 'rgba(255, 255, 255, 0.1)',
//         backdropFilter: 'blur(10px)',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//         zIndex: 999,
//         padding: '20px 40px',
//         display: 'flex',
//         justifyContent:'space-between',
//         alignItems: 'center'
//       }}
//     >
//       <div style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#DC4225' }}>
//         PaintPro Contractor
//       </div>
//       <div style={{ display: 'flex', gap: '20px' }}>
//         {['home', 'about', 'services', 'gallery', 'contact'].map((section) => (
//           <Link
//             key={section}
//             to={section}
//             spy={true}
//             smooth={true}
//             offset={-70}
//             duration={500}
//             style={{
//               cursor: 'pointer',
//               textTransform: 'capitalize',
//               fontWeight: 500,
//               color: '#333',
//               transition: 'color 0.3s'
//             }}
//             activeStyle={{ color: '#DC4225' }}
//           >
//             {section}
//           </Link>
//         ))}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


// import { useEffect, useState } from 'react';
// // import { Link } from 'react-scroll';
// import { Link } from 'react-router-dom';

// import { FaBars, FaTimes } from 'react-icons/fa';

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 100);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = ['Home', 'About', 'Services', 'Gallery', 'Contact'];

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   const closeMenu = () => {
//     setMenuOpen(false);
//   };

//   return (
//     <nav
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         zIndex: 999,
//         backgroundColor: scrolled ? '#ffffffee' : 'rgba(255, 255, 255, 0.1)',
//         backdropFilter: 'blur(10px)',
//         color: scrolled ? '#000' : '#000',
//         boxShadow: scrolled ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
//         transition: 'all 0.3s ease',
//         display: 'flex',
//         cursor:'pointer',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '15px 30px',
//       }}
//     >
//       {/* Logo */}
//       <div
//         style={{
//           fontWeight: 'bold',
//           fontSize: '1.5rem',
//           color: scrolled ? '#DC4225' : '#fff',
//           display: 'flex',
//         }}
//       >
//         <img src="https://i.ibb.co/8gKBxLS9/Javed-1.png" alt=""style={{width:'100px',height:'100px',borderRadius:'50%'}} />
//         <h2 style={{marginTop:'25px',paddingLeft:'5px'}}>Javed & Sons</h2>
//       </div>

//       {/* Desktop Nav */}
//       <div className="nav-desktop" >
//         {navItems.map((item) => (
//           <Link
//             key={item}
//             to={item.toLowerCase()}
//             smooth={true}
//             spy={true}
//             duration={500}
//             activeClass="active-link"
//             className="nav-link"
//             onClick={closeMenu}
//           >
//             {item}
//           </Link>
//         ))}
//       </div>

//       {/* Hamburger Icon */}
//       <div className="nav-mobile-icon" onClick={toggleMenu}>
//         {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="nav-mobile-menu">
//           {navItems.map((item) => (
//             <Link
//               key={item}
//               to={item.toLowerCase()}
//               smooth={true}
//               spy={true}
//               duration={500}
//               activeClass="active-link"
//               className="nav-link"
//               onClick={closeMenu}
//             >
//               {item}
//             </Link>
//           ))}
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;



// import { useEffect, useState } from 'react';
// import { Link , useLocation } from 'react-router-dom'; // ✅ Using React Router now
// import { FaBars, FaTimes } from 'react-icons/fa';

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 100);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { name: 'Home', path: '/' },
//     { name: 'About', path: '/about' },
//     { name: 'Services', path: '/services' },
//     { name: 'Gallery', path: '/gallery' },
//     { name: 'Contact', path: '/contact' },
//   ];

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   const closeMenu = () => {
//     setMenuOpen(false);
//   };

//   return (
//     <nav
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         zIndex: 999,
//         backgroundColor: scrolled ? '#ffffffee' : 'rgba(255, 255, 255, 0.1)',
//         backdropFilter: 'blur(10px)',
//         color: scrolled ? '#000' : '#000',
//         boxShadow: scrolled ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
//         transition: 'all 0.3s ease',
//         display: 'flex',
//         cursor: 'pointer',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '15px 30px',
//       }}
//     >
//       {/* Logo */}
//       <div
//         style={{
//           fontWeight: 'bold',
//           fontSize: '1.5rem',
//           color: scrolled ? '#DC4225' : '#fff',
//           display: 'flex',
//         }}
//       >
//         <img
//           src="https://i.ibb.co/8gKBxLS9/Javed-1.png"
//           alt="logo"
//           style={{ width: '100px', height: '100px', borderRadius: '50%' }}
//         />
//         <h2 style={{ marginTop: '25px', paddingLeft: '5px' }}>Javed & Sons</h2>
//       </div>

//       {/* Desktop Navigation */}
//       <div className="nav-desktop" style={{ display: 'flex', gap: '20px' }}>
//         {navItems.map((item) => (
//           <Link
//             key={item.name}
//             to={item.path}
//             className="nav-link"
//             style={{ color: scrolled ? '#000' : '#fff', textDecoration: 'none', fontSize: '16px' }}
//             onClick={closeMenu}
//           >
//             {item.name}
//           </Link>
//         ))}
//       </div>

//       {/* Mobile Menu Icon */}
//       <div className="nav-mobile-icon" onClick={toggleMenu}>
//         {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//       </div>

//       {/* Mobile Navigation Menu */}
//       {menuOpen && (
//         <div className="nav-mobile-menu" style={{ position: 'absolute', top: '80px', right: 0, background: '#fff', padding: '20px' }}>
//           {navItems.map((item) => (
//             <Link
//               key={item.name}
//               to={item.path}
//               className="nav-link"
//               style={{ display: 'block', marginBottom: '10px', textDecoration: 'none', color: '#000' }}
//               onClick={closeMenu}
//             >
//               {item.name}
//             </Link>
//           ))}
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;

// import { useEffect, useState } from 'react';
// import { NavLink, useLocation } from 'react-router-dom';
// import { FaBars, FaTimes } from 'react-icons/fa';

// const Navbar = () => {
//   const location = useLocation();
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   const handleScroll = () => {
//     setScrolled(window.scrollY > 80);
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { name: 'Home', path: '/' },
//     { name: 'About', path: '/about' },
//     { name: 'Services', path: '/services' },
//     { name: 'Gallery', path: '/gallery' },
//     { name: 'Contact', path: '/contact' },
//   ];

//   const notHome = location.pathname !== '/';
//   const toggleMenu = () => setMenuOpen(!menuOpen);
//   const closeMenu = () => setMenuOpen(false);

//   return (
//     <nav
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         zIndex: 999,
//         backgroundColor: notHome || scrolled ? '#08386894' : 'transparent',
//         color: notHome || scrolled ? '#fff' : '#000',
//         boxShadow: notHome || scrolled ? '0 2px 10px rgba(0,0,0,0.2)' : 'none',
//         transition: 'all 0.3s ease',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: scrolled ? '10px 25px' : '18px 30px',
//         height: scrolled ? '70px' : '100px',
//       }}
//     >
//       {/* Logo */}
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <img
//           src="https://i.ibb.co/8gKBxLS9/Javed-1.png"
//           alt="logo"
//           style={{
//             width: scrolled ? '60px' : '100px',
//             height: scrolled ? '60px' : '100px',
//             borderRadius: '50%',
//             transition: 'all 0.3s ease',
//           }}
//         />
//         <h2 style={{ marginLeft: '10px', fontSize: scrolled ? '20px' : '28px', color: '#fff', transition: '0.3s' }}>
//           Javed & Sons
//         </h2>
//       </div>

//       {/* Desktop Nav */}
//       <div className="nav-desktop" style={{ display: 'flex', gap: '25px', alignItems: 'center' }}>
//         {navItems.map((item) => (
//           <NavLink
//             key={item.name}
//             to={item.path}
//             onClick={closeMenu}
//             className={({ isActive }) =>
//               `nav-link ${isActive ? 'active-link' : ''}`
//             }
//             style={{
//               color: '#fff',
//               textDecoration: 'none',
//               fontWeight: 500,
//               fontSize: '16px',
//               borderBottom: '2px solid transparent',
//               paddingBottom: '4px',
//             }}
//           >
//             {item.name}
//           </NavLink>
//         ))}
//       </div>

//       {/* Mobile Menu Icon */}
//       <div className="nav-mobile-icon" onClick={toggleMenu}>
//         {menuOpen ? <FaTimes size={24} color="#fff" /> : <FaBars size={24} color="#fff" />}
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="nav-mobile-menu" style={{
//           position: 'absolute',
//           top: '100px',
//           right: 0,
//           background: '#003366',
//           padding: '20px',
//           width: '100%',
//           textAlign: 'center'
//         }}>
//           {navItems.map((item) => (
//             <NavLink
//               key={item.name}
//               to={item.path}
//               onClick={closeMenu}
//               className={({ isActive }) =>
//                 `nav-link ${isActive ? 'active-link' : ''}`
//               }
//               style={{
//                 display: 'block',
//                 marginBottom: '10px',
//                 textDecoration: 'none',
//                 color: '#fff',
//                 fontSize: '18px',
//               }}
//             >
//               {item.name}
//             </NavLink>
//           ))}
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;


// import { useEffect, useState } from 'react';
// import { NavLink, useLocation } from 'react-router-dom';
// import { FaBars, FaTimes } from 'react-icons/fa';
// import OurTeam from './ourteam';

// const Navbar = () => {
//   const location = useLocation();
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [servicesDropdown, setServicesDropdown] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 80);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const notHome = location.pathname !== '/';

//   const navItems = [
//     { name: 'Home', path: '/' },
//     { name: 'About', path: '/about' },
//     {
//       name: 'Services',
//       path: '/services',
//       hasDropdown: true,
//       subPages: [
//         { name: 'Interior', path: '/services/interior' },
//         { name: 'Ceiling', path: '/services/ceiling' },
//         { name: 'Exterior', path: '/services/exterior' },
//         { name: 'Marquee', path: '/services/marquee' },
//         { name: 'Flour', path: '/services/flour' },
//         { name: 'Games', path: '/services/games' },

//       ],
//     },
//     { name: 'Gallery', path: '/gallery' },
//     { name: 'Contact', path: '/contact' },
//   ];

//   const toggleMenu = () => setMenuOpen(!menuOpen);
//   const closeMenu = () => {
//     setMenuOpen(false);
//     setServicesDropdown(false);
//   };

//   return (
//     <nav
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         zIndex: 999,
//         backgroundColor: notHome || scrolled ? '#008080b0' : 'transparent',
//         color: notHome || scrolled ? '#fff' : '#000',
//         boxShadow: notHome || scrolled ? '0 2px 10px rgba(0,0,0,0.2)' : 'none',
//         transition: 'all 0.3s ease',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: scrolled ? '10px 25px' : '18px 30px',
//         height: scrolled ? '70px' : '100px',
//       }}
//     >
//       {/* Logo */}
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <img
//           src="https://i.ibb.co/8gKBxLS9/Javed-1.png"
//           alt="logo"
//           style={{
//             width: scrolled ? '60px' : '100px',
//             height: scrolled ? '60px' : '100px',
//             borderRadius: '50%',
//             transition: 'all 0.3s ease',
//           }}
//         />
//         <h2 style={{ marginLeft: '10px', fontSize: scrolled ? '20px' : '28px', color: '#fff', transition: '0.3s' }}>
//           Javed & Sons
//         </h2>
//       </div>

//       {/* Desktop Menu */}
//       <div className="nav-desktop" style={{ display: 'flex', gap: '25px', alignItems: 'center' }}>
//         {navItems.map((item) =>
//           item.hasDropdown ? (
//             <div
//               key={item.name}
//               style={{ position: 'relative' }}
//               onMouseEnter={() => setServicesDropdown(true)}
//               onMouseLeave={() => setServicesDropdown(false)}
//             >
//               <NavLink
//                 to={item.path}
//                 className="nav-link"
//                 style={{
//                   color: '#fff',
//                   textDecoration: 'none',
//                   fontWeight: 500,
//                   fontSize: '16px',
//                 }}
//               >
//                 {item.name} ▼
//               </NavLink>

//               {servicesDropdown && (
//                 <div
//                   style={{
//                     position: 'absolute',
//                     top: '30px',
//                     left: 0,
//                     backgroundColor: '#fff',
//                     padding: '10px',
//                     borderRadius: '4px',
//                     boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                   }}
//                 >
//                   {item.subPages.map((sub) => (
//                     <NavLink
//                       key={sub.name}
//                       to={sub.path}
//                       style={{
//                         display: 'block',
//                         padding: '6px 12px',
//                         textDecoration: 'none',
//                         color: '#003366',
//                       }}
//                       onClick={closeMenu}
//                     >
//                       {sub.name}
//                     </NavLink>
//                   ))}
//                 </div>
//               )}
//             </div>
//           ) : (
//             <NavLink
//               key={item.name}
//               to={item.path}
//               className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}
//               style={{
//                 color: '#fff',
//                 textDecoration: 'none',
//                 fontWeight: 500,
//                 fontSize: '16px',
//               }}
//               onClick={closeMenu}
//             >
//               {item.name}
//             </NavLink>
//           )
//         )}
//       </div>

//       {/* Mobile Icon */}
//       <div className="nav-mobile-icon" onClick={toggleMenu}>
//         {menuOpen ? <FaTimes size={24} color="#fff" /> : <FaBars size={24} color="#fff" />}
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div
//           className="nav-mobile-menu"
//           style={{
//             position: 'absolute',
//             top: '100px',
//             right: 0,
//             background: '#0033667c',
//             padding: '20px',
//             width: '50%',
//             textAlign: 'center',
//           }}
//         >
//           {navItems.map((item) => (
//             <div key={item.name}>
//               <NavLink
//                 to={item.path}
//                 className={({ isActive }) => `nav-link ${isActive ? 'active-link' : ''}`}
//                 style={{
//                   display: 'block',
//                   marginBottom: '10px',
//                   textDecoration: 'none',
//                   color: '#fff',
//                   fontSize: '18px',
//                 }}
//                 onClick={closeMenu}
//               >
//                 {item.name}
//               </NavLink>
//               {item.hasDropdown &&
//                 item.subPages.map((sub) => (
//                   <NavLink
//                     key={sub.name}
//                     to={sub.path}
//                     style={{
//                       display: 'block',
//                       marginLeft: '15px',
//                       marginBottom: '8px',
//                       textDecoration: 'none',
//                       color: '#ddd',
//                       fontSize: '16px',
//                     }}
//                     onClick={closeMenu}
//                   >
//                     {sub.name}
//                   </NavLink>
//                 ))}
//             </div>
//           ))}
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;




import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
// import "./Navbar.css";

const Navbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMenuOpen(false);
        setServicesDropdown(false);
      }
    };
    const handleScroll = () => setScrolled(window.scrollY > 80);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const notHome = location.pathname !== "/";

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about",
      hasDropdown: true, 
      subPages: [
        { name: "Workers", path: "/about/labour" },
      ],
    },
    {
      name: "Services",
      path: "/services",
      hasDropdown: true,
      subPages: [
        { name: "Interior", path: "/services/interior" },
        { name: "Ceiling", path: "/services/ceiling" },
        { name: "Exterior", path: "/services/exterior" },
        { name: "Marquee", path: "/services/marquee" },
        { name: "Flour", path: "/services/flour" },
        { name: "Games", path: "/services/games" },
      ],
    },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setServicesDropdown(false);
  };
  const toggleServices = () => setServicesDropdown((prev) => !prev);

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 999,
        backgroundColor: notHome || scrolled ? "#008080b0" : "transparent",
        color: "#fff",
        boxShadow: notHome || scrolled ? "0 2px 10px rgba(0,0,0,0.2)" : "none",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: scrolled ? "10px 25px" : "18px 30px",
        height: scrolled ? "70px" : "100px",
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="https://i.ibb.co/8gKBxLS9/Javed-1.png"
          alt="logo"
          style={{
            width: scrolled ? "60px" : "100px",
            height: scrolled ? "60px" : "100px",
            borderRadius: "50%",
            transition: "all 0.3s ease",
          }}
        />
        <h2
          style={{
            marginLeft: "10px",
            fontSize: scrolled ? "20px" : "28px",
            color: "#fff",
            transition: "0.3s",
          }}
        >
          Javed & Sons
        </h2>
      </div>

      {/* Desktop Menu */}
      {!isMobile && (
        <div className="nav-desktop" style={{ gap: "25px", alignItems: "center" }}>
          {navItems.map((item) =>
            item.hasDropdown ? (
              <div
                key={item.name}
                style={{ position: "relative" }}
                onMouseEnter={() => setServicesDropdown(true)}
                onMouseLeave={() => setServicesDropdown(false)}
              >
                <NavLink
                  to={item.path}
                  style={{ color: "#fff", textDecoration: "none", fontWeight: 500, fontSize: "16px" }}
                >
                  {item.name} ▼
                </NavLink>
                {servicesDropdown && (
                  <div className="dropdown">
                    {item.subPages.map((sub) => (
                      <NavLink
                        key={sub.name}
                        to={sub.path}
                        className="dropdown-item"
                        onClick={closeMenu}
                      >
                        {sub.name}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <NavLink
                key={item.name}
                to={item.path}
                style={{ color: "#fff", textDecoration: "none", fontWeight: 500, fontSize: "16px" }}
                onClick={closeMenu}
              >
                {item.name}
              </NavLink>
            )
          )}
        </div>
      )}

      {/* Mobile Icon */}
      {isMobile && (
        <div className="nav-mobile-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes size={24} color="#fff" /> : <FaBars size={24} color="#fff" />}
        </div>
      )}

      {/* Mobile Menu */}
      <div className={`nav-mobile-menu ${menuOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <div key={item.name}>
            {item.hasDropdown ? (
              <>
                <div
                  className="mobile-link"
                  onClick={toggleServices}
                >
                  {item.name} {servicesDropdown ? "▲" : "▼"}
                </div>
                <div className={`mobile-submenu ${servicesDropdown ? "show" : ""}`}>
                  {item.subPages.map((sub) => (
                    <NavLink
                      key={sub.name}
                      to={sub.path}
                      className="mobile-sublink"
                      onClick={closeMenu}
                    >
                      {sub.name}
                    </NavLink>
                  ))}
                </div>
              </>
            ) : (
              <NavLink
                to={item.path}
                className="mobile-link"
                onClick={closeMenu}
              >
                {item.name}
              </NavLink>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
